<template>
    <div class="shadow-lg rounded-lg relative select-none" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave"
        :class="{
            'text-gray-800': searchSelected(row.id),
            'text-gray-800': !searchSelected(row.id),
        }" :style="{
            background: 'linear-gradient(to top left, #f2ebd2, #f2e7cb)' // Gradient padrão atualizado
        }">

        <!-- Exibição de "Novo" -->
        <div v-if="row.new" class="absolute">
            <span class="inline-flex items-center px-1 py-0.5 rounded text-xs font-medium bg-cyan-800 text-white ml-2">
                Novo
            </span>
        </div>

        <!-- Área do botão -->
        <div
            class="group w-full flex flex-col items-center rounded-md border-gray-200 shadow-sm text-left relative h-[200px]">

            <!-- Vídeo ou imagem de fundo -->
            <div class="absolute bottom-0 left-1 w-[250px] h-[200px]">
                <!-- Imagem de fundo sempre visível -->
                <img :src="getAvatar()"
                    class="absolute inset-0 w-full h-full object-cover transition-opacity duration-300"
                    :class="{ 'opacity-100': !videoLoaded, 'opacity-0': videoLoaded }" alt="Background" />

                <!-- Vídeo sobreposto e escondido até estar pronto -->
                <video v-if="videoSrc" :src="videoSrc" autoplay loop muted playsinline
                    class="absolute inset-0 w-full h-full object-cover transition-opacity duration-500"
                    :class="{ 'opacity-0': !videoLoaded, 'opacity-100': videoLoaded }" @canplay="videoLoaded = true">
                </video>
            </div>

            <div class="w-full h-full flex relative z-10">
                <!-- Coluna Esquerda -->
                <div class="w-2/4 min-w-[200px]"></div>

                <!-- Coluna Direita -->
                <div class="w-2/4 flex flex-col items-center justify-center">
                    <img :src="row.avatar" alt="avatar" class="rounded-full object-cover h-20 w-20 border bg-white" />
                    <div class="text-xl font-semibold text-center truncate w-full px-2">
                        {{ row.name }}
                    </div>
                    <div class="text-xs text-center">
                        {{ row.agent_personality }}
                    </div>
                </div>
            </div>

            <div class="w-full flex gap-1 items-end justify-end p-2">
                <div v-if="row.whatsapp_web.status == 'connected'">
                    <img src="/imgs/logos/whatsapp.svg" alt="WhatsApp Web" class="h-6" />
                </div>
                <div v-if="row.whatsapp_api.status == 'connected'">
                    <img src="/imgs/logos/whatsapp_business.png" alt="WhatsApp API" class="h-6" />
                </div>
                <div v-if="row.messenger.status == 'connected'">
                    <img src="/imgs/logos/messenger.svg" alt="Messenger" class="h-6" />
                </div>
                <div v-if="row.instagram.status == 'connected'">
                    <img src="/imgs/logos/instagram.svg" alt="Instagram" class="h-6" />
                </div>
                <div v-if="row.widget.status == 'connected'">
                    <img src="/imgs/logos/chat.png" alt="Webchat" class="h-6" />
                </div>
                <div v-if="row.telegram.status == 'connected'">
                    <img src="/imgs/logos/telegram.svg" alt="Telegram" class="h-6" />
                </div>
                <div v-if="row.twitter.status == 'connected'"></div>
            </div>

        </div>

    </div>
</template>

<script>
import { XCircleIcon } from '@heroicons/vue/24/solid';

export default {
    name: "UserCardSmall",
    props: {
        row: {
            type: Object,
            required: true
        },
        status: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Array,
            required: false
        }
    },
    components: {
        XCircleIcon,
    },
    data() {
        return {
            isHovered: false,
            videoLoaded: false,
            videoSrc: '' // Caminho do vídeo, será definido dinamicamente
        };
    },
    methods: {
        getAvatar() {
            if (this.row?.attributes?.assistent?.personagem) {
                return this.row.attributes.assistent.personagem.replace('/p', '/g');
            }
            return '/imgs/wbuy_ai.png';
        },

        getVideoPath() {
            if (this.row?.attributes?.assistent?.personagem) {

                console.log(this.row.attributes.assistent.personagem)
                return this.row.attributes.assistent.personagem.replace('.png', '.mp4').replace('/p', '/v');
            }
            return '';
        },

        handleMouseEnter() {
            this.isHovered = true;
            this.videoSrc = this.getVideoPath();
            this.checkVideoExists(this.videoSrc);
        },

        handleMouseLeave() {
            this.isHovered = false;
            this.videoLoaded = false; // Reseta para evitar erro ao sair do hover
        },

        async checkVideoExists(videoUrl) {
            if (!videoUrl) {
                this.videoLoaded = false;
                return;
            }

            try {
                const response = await fetch(videoUrl, { method: 'HEAD' });
                this.videoLoaded = response.ok;
            } catch (error) {
                this.videoLoaded = false;
            }
        },

        searchSelected(id) {
            return this.selected.indexOf(id) > -1;
        }
    }
};
</script>

<style scoped>
.card-container {
    @apply relative w-full h-48 overflow-hidden rounded-lg shadow-lg transition-all duration-300;
}
</style>
